const messages = {
  en: require('./language/en.json'),
  zh: require('./language/zh.json')
}

export default messages
